import React, { useMemo } from 'react';
import {
  string, number,
} from 'prop-types';
import isNil from 'lodash/isNil';
import Locale from '@active/react-utils/i18n/Locale';
import Currency from '../../Currency';
import StaticField from './components/StaticField';
import paymentMethodsMap from '../../../../shared/config/paymentMethodsMap';
import { IMAGE_VALUES } from './components/CreditCardInfoField/CreditCardInfoField';

const maskLabel = (type) => {
  if (type === 'EUDD') {
    return 'checkout.lib.components.payment.eudd.iban';
  }
  if (type === 'ECP') {
    return 'checkout.lib.components.payment.echeck.account';
  }
  return 'checkout.lib.components.common.card.number'; // CREDIT_CARD
};

const PaymentInfoFields = ({
  maskedNumber,
  tenderType,
  type,
  amount,
  currencyCode,

  holderName,
  expirationDate,
  accountType,
}) => {
  const holderNameLabel = useMemo(() => (tenderType === 'CREDIT_CARD' ? 'checkout.lib.components.common.holder.name' : 'checkout.lib.components.payment.echeck.name'), [ tenderType ]);
  const AmountPaidText = () => {
    if (amount === 0) {
      return <Locale id='checkout.lib.components.text.noAmountPaid' />;
    }
    return <Currency amount={amount} code={currencyCode} />;
  };

  if (!paymentMethodsMap[tenderType]) {
    return null;
  }

  return <div className="payment-info__fields">
    <StaticField
      label="checkout.lib.components.paymentResult.paymentMethod">
      <Locale id={paymentMethodsMap[tenderType]} />
      { tenderType === 'APPLEPAY' && <i className="apple-pay-icon payment-info__apple-pay-icon"/> }
      { tenderType === 'GOOGLEPAY' && <i className="google-pay-icon payment-info__google-pay-icon"/> }
    </StaticField>
    <StaticField
      label={holderNameLabel}>
      {holderName}
    </StaticField>
    {!isNil(maskedNumber)
    && <StaticField
      label={maskLabel(type)}
      values={IMAGE_VALUES}>
      {maskedNumber}
    </StaticField>
    }
    <StaticField
      label="checkout.lib.components.common.expiration.date">
      {expirationDate}
    </StaticField>
    {accountType && <StaticField
      label="checkout.lib.components.payment.echeck.type">
      <Locale id={`checkout.lib.components.payment.echeck.${accountType}`}/>
    </StaticField>}
    { !isNil(currencyCode) && !isNil(amount)
      && <StaticField
        label="checkout.lib.components.paymentResult.detail.paymentInfo.amountPaid">
        <AmountPaidText />
      </StaticField>
    }
  </div>;
};

PaymentInfoFields.propTypes = {
  maskedNumber: string,
  tenderType: string,
  type: string,
  holderName: string,
  expirationDate: string,
  accountType: string,
  amount: number,
  currencyCode: string,
};

export default PaymentInfoFields;
